import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';

/**
 * Nombres de los miembros de la empresa, para "Generada por Juli" en Creaciones
 * (spec 2026-09-11-invitaciones-equipo §6.2). `varios` es `false` con un solo miembro: ahí la
 * línea no se muestra, y para el 99 % de las cuentas la pantalla no cambia. Una consulta por
 * montaje; la política de `profiles` permite leer los de la propia empresa.
 */
export function useNombresDelEquipo(idCompany: string | null): {
  varios: boolean;
  nombreDe: (userId: string | null | undefined) => string | null;
} {
  const [mapa, setMapa] = useState<Map<string, string>>(new Map());
  useEffect(() => {
    if (!idCompany) return;
    let activo = true;
    supabase
      .from('profiles')
      .select('id, name, email')
      .eq('id_company', idCompany)
      .then(({ data }) => {
        if (!activo || !data) return;
        const m = new Map<string, string>();
        for (const p of data as { id: string; name: string | null; email: string | null }[]) {
          m.set(p.id, p.name?.trim() || (p.email ?? '').split('@')[0] || 'Alguien');
        }
        setMapa(m);
      });
    return () => {
      activo = false;
    };
  }, [idCompany]);
  return {
    varios: mapa.size > 1,
    nombreDe: (userId) => (userId ? (mapa.get(userId) ?? null) : null),
  };
}

export default useNombresDelEquipo;
